import { Country } from '@appTypes/api.types';

/**
 * The destination a search form opens with.
 *
 * Amiran, 23.09.2026: "destination chooser tab disapeared from only hotels why ?" - the form opened on the country remembered in the
 * browser (first visit: the built-in default), which the Destination Module no longer offered, so the chooser showed nothing while the
 * page still listed that country's cities and hotels.
 *
 * Order: the country the form already holds, when it is offered; else the default the API names (the Destination Module's, DEST-011),
 * when offered; else the first country offered. With nothing offered the form keeps what it holds - there is nothing better to show.
 */
export function pickDestinationCountry(
  current: string | null | undefined,
  offered: readonly Country[] | null | undefined,
  apiDefault: string | null | undefined
): string | null {
  const codes = (offered ?? []).map((c) => c.countryCode).filter((c): c is string => !!c);
  if (!codes.length) return current ?? null;
  if (current && codes.includes(current)) return current;
  if (apiDefault && codes.includes(apiDefault)) return apiDefault;
  return codes[0];
}
